import React from 'react';
import { Navbar, Image, Button } from 'react-bootstrap';
import { handleBackClick, handleMenuItemClick } from 'components/views/PublicRoom/_helpers/publicRoom.events';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { $app, $user } from 'signals/global.signals';

const PublicRoomHeader = () => {
  const toggleMenu = () => {
    $app.value = {
      ...$app.value,
      isMenuOpen: !$app.value.isMenuOpen || false,
    };
  };

  return (
    <Navbar
      expand="lg"
      style={{ zIndex: 1010 }}
      className="navbar navbar-expand-lg px-32 bg-gradient-dark-primary sticky-top"
    >
      <Navbar.Brand>
        <Button
          onClick={handleBackClick}
          variant="link"
          className="text-white border-0"
          type="button"
        >
          <FontAwesomeIcon icon={faArrowLeft} className="ms-16" size="lg" />
        </Button>
      </Navbar.Brand>
      <Navbar.Brand className="ms-auto" href={$user.value.id ? '/' : 'https://dealsend.com'}>
        <Image
          src="/images/logo-light.svg"
          alt="DealSend Logo"
          style={{ height: '50px' }}
        />
      </Navbar.Brand>

      <Button
        variant="transparent"
        className={` d-lg-none custom-menu-button ${$app.value.isMenuOpen ? 'is-active' : ''}`}

        onClick={toggleMenu}
      >
        <span />
        <span />
        <span />
      </Button>
    </Navbar>
  );
};

export default PublicRoomHeader;
